export class CatalogItemObject {
    private _name: string;
    private _version: string;
    private _id: string;

    constructor(name: string, version: string, id: string) {
        this._name = name;
        this._version = version;
        this._id = id;
    }

    static create(): CatalogItemObject {
        return new CatalogItemObject('', '', '');
    }

    public get name(): string {
        return this._name;
    }

    public get version(): string {
        return this._version;
    }

    public get id(): string {
        return this._id;
    }

}
